
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post58() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal, fui diagnosticada com diabetes tipo 1 e to tomando insulina. Me ensinaram a aplicar na barriga, mas queria saber se dá pra aplicar na coxa e se dói menos</title>
        <meta 
          name="description" 
          content="Oi pessoal, fui diagnosticada com diabetes tipo 1 e to tomando insulina. Me ensinaram a aplicar na barriga, mas queria saber se dá pra aplicar na coxa e se dói menos"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Danna Rosa &#183; 10/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal, fui diagnosticada com diabetes tipo 1 e to tomando insulina. Me ensinaram a aplicar na barriga, mas queria saber se dá pra aplicar na coxa e se dói menos
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/58')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  1 pessoa achou útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Danna, tudo bem?<br/><br/>Primeiramente, sinto muito pelo seu diagnóstico, diabetes tipo 1 pode ser um desafio, mas com o tempo você vai se adaptando e encontrando o que funciona melhor pra você.<br/><br/>Você pode sim aplicar insulina na coxa. Na verdade, você pode aplicar em várias áreas do corpo, como barriga, coxa, parte superior do braço e até nas nádegas. É até recomendado variar os locais de aplicação para evitar que a pele fique irritada ou desenvolva lipodistrofia (uma condição em que a gordura sob a pele se quebra).<br/><br/>Quanto à dor, isso pode variar de pessoa para pessoa e também depende um pouco da técnica utilizada. Tente escolher uma área da coxa que tenha um pouco mais de gordura e esteja longe de grandes veias ou nervos. Outra dica é alternar os locais de aplicação e usar agulhas novas e finas, pois isso pode ajudar a reduzir a dor.<br/><br/>Claro, é sempre bom conversar com seu médico ou enfermeiro antes de mudar sua rotina de aplicação de insulina. Eles podem te dar orientações específicas e garantir que você está fazendo tudo de maneira segura.<br/><br/>Espero ter ajudado! Se tiver mais dúvidas, estamos aqui para você.<br/><br/>Um abraço!
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 10/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/58')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marlene Techini &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/35-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal<br/>Alguém trocou propranolol por metoprolol?<br/>Tem alguma diferença significativa?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/35')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Joana Ling &#183; 10/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/56-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Quem tem diabetes pode comer cenoura?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/56')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Elisa Orta &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/141-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde. Vou em um rodízio de sushi amanhã, como faço a contagem de carboidratos?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/141')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mariano Oliveira &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/82-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, bom dia! Alguém aqui já viu nos exames o termo opacidade nodular? Pode me ajudar com oque significa.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/82')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Leonardo Silveira &#183; 18/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/2-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Os benefícios para saúde de ter um Border Collie  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há anos atrás, quando estava na faculdade, eu costumava correr na rua em algum parque 2 ou 3 vezes na semana, por cerca de 30 minutos. Com o tempo, e conforme fui ficando mais ocupado, acabei deixando esse bom hábito de lado. E uma vez que o hábito de exercício físico normalmente traz consigo outros hábitos, como de uma alimentação mais saudável e menos bebida alcoólica, esses também foram se deteriorando com o tempo. Consequentemente, ao longo dos anos sutilmente resultados disso foram surgindo, como aumento de peso e menor disposição.<br/><br/>Dois anos atrás, porém, decidi junto com minha esposa adotar um cachorro, e escolhemos uma Border Collie. A nova integrante da família, conforme nós esperávamos, nos forçou a uma série de mudanças na rotina. Eu fiquei responsável pelos passeios duas vezes por dia: às 6 da manhã, antes do trabalho, e no final da tarde. Isso me forçou diretamente e sem rodeios a iniciar uma atividade física disfarçada, que foram as caminhadas com nossa cachorra, que foram aumentando de duração e intensidade conforme ele crescia.<br/><br/>A raça Border Collie é conhecida por ser a raça mais inteligente, e também de alta energia. E sem dúvida existe alguma verdade nessa afirmação. As caminhadas deixaram de ser o bastante para a nossa cachorra, e para conseguir gastar sua energia e mantê-la saudável treinamos ela para jogar frisbee: pegar o disco no ar após jogarmos e traze-lo novamente para nós, em um ciclo aparentemente infinito de arremessos. Ela aprendeu rapidamente o esporte e se tornou um dos melhores cachorros que já vimos pegando o disco no ar em saltos acrobáticas.<br/> <br/>Porém, as caminhadas intensas duas vezes por dia com ela me fez lembrar de como eu me sentia bem após uma corrida intensa na época da faculdade, e como estava disposto no dia seguinte para o estudo e trabalho. Com isso, comecei aos poucos a correr junto de minha cachorra na rua. Essa corrida foi aumentando, primeiro somente a tarde alguns dias, depois mais alguns dias de manhã, e por fim, hoje corro com ela todos os dias de manhã e a tarde.<br/><br/>Isso mantém minha cachorra feliz e nós dois saudáveis, além de me manter disposto e com mais energia do que me sentia em anos. E hoje nem penso em não fazer isso, simplesmente porque sei como me sinto e vejo como ela fica feliz na horário dos nossos passeios. Esse são alguns, dos muitos benefícios de ter um Border Collie (ou qualquer outro cachorro) como companheiro.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/2')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
